module.exports = __webpack_public_path__ + "static/eramuk-1ae5464e95b32ceaf60af470cc242368.jpg";